import { Chip } from "@amzn/stencil-react-components/chip";
import { Input, InputFooter, InputHeader } from "@amzn/stencil-react-components/input";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Label, Text } from "@amzn/stencil-react-components/text";
import { TextArea } from "@amzn/stencil-react-components/text-area";
import React, { FC } from "react";

export interface FormFieldProps {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  chipText?: string;
  testId: string;
  isTextArea?: boolean;
  tooltipText?: string;
  required?: boolean;
  disabled?: boolean;
  description?: string;
  error?: string;
}

export const FormField: FC<FormFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  chipText,
  testId,
  isTextArea,
  tooltipText,
  required,
  disabled,
  description,
  error,
}) => {
  const hasError = !!error;

  const header = (
    <InputHeader
      labelText={label}
      htmlFor={testId}
      tooltipText={tooltipText}
      required={required}
      error={hasError}
    />
  );

  return (
    <Col gridGap="S200">
      {description ? (
        <Row gridGap="S100" alignItems="end">
          {header}
          <Label color="neutral70" fontSize="T100">{description}</Label>
        </Row>
      ) : (
        <Row>{header}</Row>
      )}
      {isTextArea ? (
        <TextArea
          data-testid={testId}
          id={testId}
          resize="none"
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          error={hasError}
          aria-invalid={hasError}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange?.(e.target.value)}
        />
      ) : (
        <Input
          data-testid={testId}
          id={testId}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          error={hasError}
          aria-invalid={hasError}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value)}
        />
      )}
      {hasError && (
        <InputFooter id={`${testId}-error`} error data-testid={`${testId}-error`}>
          {error}
        </InputFooter>
      )}
      {chipText && (
        <Chip>
          <Text color="neutral90" fontSize="T100">
            {chipText}
          </Text>
        </Chip>
      )}
    </Col>
  );
};
